import { render, staticRenderFns } from "./ReviewsFullListController.vue?vue&type=template&id=029063c0&scoped=true&"
import script from "./ReviewsFullListController.vue?vue&type=script&lang=ts&"
export * from "./ReviewsFullListController.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewsFullListController.vue?vue&type=style&index=0&id=029063c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029063c0",
  null
  
)

export default component.exports